import {combineReducers} from 'redux'
import document from './document'
import hubspot from './hubspot'
import mailchimp from './mailchimp'
import oneDrive from './oneDrive'
import quickBooks from './quickBooks'
import shopify from './shopify'
import xero from './xero'
import zoho from './zoho'
import sage from './sage'
import sharePoint from './sharePoint'

export default combineReducers({
  document,
  hubspot,
  sage,
  mailchimp,
  oneDrive,
  quickBooks,
  sharePoint,
  shopify,
  xero,
  zoho,
})
